import React from 'react';
import { RadioGroupWrapper } from './RadioGroup.styles';
import { RadioButton } from '../../atoms';
import { RadioGroupProps } from './types';

const RadioGroup = ({
  options,
  onValueChange,
  selectedValue,
  optionsDirection = 'row',
  optionsGap = 5,
}: RadioGroupProps) => (
  <RadioGroupWrapper gridGap={optionsGap} flexDirection={optionsDirection}>
    {options.map((option) => (
      <RadioButton
        key={option.value}
        isSelected={selectedValue === option.value}
        label={option.label}
        value={option.value}
        onValueChange={(value) => onValueChange(value)}
      />
    ))}
  </RadioGroupWrapper>
);

export default RadioGroup;
